const constructors = new Map();
export function register(type, constructor) {
    constructors.set(type, constructor);
}
export function factory(track) {
    const constructor = constructors.get(track.type);
    if (!constructor) {
        throw RangeError(`No track factory constructor for ${JSON.stringify(track)}`);
    }
    return new constructor(track);
}
export default factory;
//# sourceMappingURL=factory.js.map